import { useWindowDimensions } from 'react-native';
const useFixedHeader = ({ offSet = 0 }) => {
    const windowWidth = useWindowDimensions().width;
    return windowWidth - offSet;
};
export default useFixedHeader;
//# sourceMappingURL=useFixedLayout.js.map